/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TestService {

    /**
     * Reset test data
     * @returns any Success
     * @throws ApiError
     */
    public static resetTestData({
        requestBody,
    }: {
        requestBody: {
            email: string;
        },
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Seed test data
     * @returns any Success
     * @throws ApiError
     */
    public static seedTestData({
        requestBody,
    }: {
        requestBody: {
            email: string;
            data: any[];
        },
    }): CancelablePromise<{
        createdItems?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/seed',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get user context for test orchestration
     * @returns any Success
     * @throws ApiError
     */
    public static getUserInfo({
        requestBody,
    }: {
        requestBody: {
            email: string;
        },
    }): CancelablePromise<{
        user?: {
            id?: number;
            emailAddress?: string;
            companyId?: number;
        };
        companyCode?: string;
        companyTenancy?: string;
        currencies?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/userInfo',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Seed Platform test data
     * @returns any Success
     * @throws ApiError
     */
    public static seedPlatform({
        requestBody,
    }: {
        requestBody: {
            email: string;
            items: Array<{
                type?: string;
                alias?: string;
                data?: Record<string, any>;
            }>;
            /**
             * Previously created items from other phases (e.g., DataHub)
             */
            createdItems?: Record<string, any>;
        },
    }): CancelablePromise<{
        createdItems?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/seedPlatform',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Seed feature flags
     * @returns any Success
     * @throws ApiError
     */
    public static seedFeatureFlags({
        requestBody,
    }: {
        requestBody: {
            email: string;
            featureFlags: Record<string, any>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/seedFeatureFlags',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get test user
     * @returns any Success
     * @throws ApiError
     */
    public static getTestUser(): CancelablePromise<{
        email: string;
        password: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/getTestUser',
            errors: {
                400: `Validation error`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Promote test user to super admin
     * @returns any Success
     * @throws ApiError
     */
    public static promoteUserToSuperAdmin({
        requestBody,
    }: {
        requestBody: {
            email: string;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/promoteTestUser',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Release test user
     * @returns any Success
     * @throws ApiError
     */
    public static releaseTestUser({
        requestBody,
    }: {
        requestBody: {
            email: string;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/releaseTestUser',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Auth test user
     * @returns any Success
     * @throws ApiError
     */
    public static authTestUser({
        requestBody,
    }: {
        requestBody: {
            email: string;
            password: string;
        },
    }): CancelablePromise<{
        token: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/auth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Seed search index data
     * @returns any Success
     * @throws ApiError
     */
    public static seedSearchIndex({
        requestBody,
    }: {
        requestBody: {
            email: string;
            seedCompanyJob?: boolean;
            seedSurveyJob?: boolean;
        },
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/test/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

}
